import { NgModule, ModuleWithProviders } from '@angular/core';
import { SessionService } from '../_services/_index';
import { LoadingMaterialComponent } from '../components/loading-material/loading-material.component';
import { CommonModule } from '@angular/common';
import { SnackBarService } from '../_services/snackbar.service';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AlertComponent } from '../dialogs';
import { DisableControlDirective } from '../directives/disable-control.directive';
import { ScriptLoaderService } from '../_services/utils/script-loader.service';
import { SnackBarInfoComponent } from '../dialogs/snackbar-info/snackbar-info.component';
import { ErrorService } from '../_services/error.service';
import { ReingresarDialog } from '../dialogs/reingresar-dialog/reingresar-dialog.component';
import { IngresarDialogModule } from '../dialogs/reingresar-dialog/reingresar-dialog.module';
import { DialogService } from '../_services/dialog.service';

@NgModule({
	exports: [
		LoadingMaterialComponent,
		AlertComponent,
		SnackBarInfoComponent,
		DisableControlDirective,
	],
	declarations: [
		LoadingMaterialComponent,
		AlertComponent,
		SnackBarInfoComponent,
		DisableControlDirective,
	],
	imports: [
		CommonModule,
		MatSnackBarModule,
		MatButtonModule,
		IngresarDialogModule,
	],
	entryComponents: [AlertComponent, SnackBarInfoComponent, ReingresarDialog],
})
export class GeneralModule {
	static forRoot(): ModuleWithProviders<GeneralModule> {
		return {
			ngModule: GeneralModule,
			providers: [
				SessionService,
				ErrorService,
				SnackBarService,
				ScriptLoaderService,
				DialogService,
			],
		};
	}
}
